<template>
  <div class="report-section report-section-header">
    <h1 data="$title">{{ reportData.report_title }}</h1>
    <p><span>{{ reportData.greeting }}</span></p>
    <p><span>{{ reportData.duration }}</span></p>
    <p><span>{{ reportData.create_time }}</span></p>
  </div>
</template>

<script>
export default {
  name: 'ReportHeader',
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="less" scoped>
.report-section-header {
  // background-color: rgb(124, 124, 238);
  color: #fff;
  border-bottom: 1px solid #e5e6eb;
  // box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
</style>
